module.exports = __webpack_public_path__ + "76aa67ab840a389f03496c05b895dcda.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/run/apple-touch-icon.png
// module id = 1850
// module chunks = 1